





























import { Vue, Component, Emit } from 'vue-property-decorator'
import { FormRule } from '@/types/formRules.d.ts'
import NbFormItem from '@/components/NbForm/index.vue'
import { PlanCategorylList } from '@/api/plainAdmin'
import { vaildW } from '@/utils/vaild'
import { cusElForm } from '@/types/form'
@Component({
  components: {
    NbFormItem,
  }
})
export default class Step1 extends Vue {
  /**
   * category  计划分组 select
   *    name
   *    id
   * categoryArr 计划分组下拉框内容
   *    {} name , id
   *
   * code  编码
   * name  运营计划名称
   * object 对象id
   * planCategoryId 计划所属类目
   * description  说明
   */
  type:any= ''
  form: any = {
    categoryId: '',
    categoryArr: [],
    name: '',
    code: '',
    description: ''
  }
  // nextStatus = false // 下一步状态/
  validatePass = (rule:any, value:any, cb:any) => {
    if (!vaildW.test(value)) {
      // this.nextStatus = false
      cb(new Error('校验不通过，编码仅支持大小写字母，请检查您的编码'))
      return
    }
    // this.nextStatus = true
    cb()
  }
  rules:any = {
    code: { required: true, validator: this.validatePass, trigger: 'blur' },
    name: { required: true, message: '请输入计划名请输入计划说明', trigger: 'blur' },
    description: { required: true, message: '请输入计划名称', trigger: 'blur' },
    categoryId: { required: true, message: '请选择分组计划', trigger: 'change' },
  }

  // 规则校验状态
  vaildSubmit(cb: Function) {
    (this.$refs.form as cusElForm).validate((valid: boolean) => {
      if (valid) {
        cb(valid, this.form)
      } else {
        cb(valid)
        return false
      }
    })
  }
  created() {
    this.handleType()
  }

  /**
   * 获取计划分组列表
   * getCategoryList
   */
  async getCategoryList(objectId:any) {
    return (await PlanCategorylList({ objectId })).data
  }
  /**
   * 类型处理 add or edit
   */
  handleType() {
    const { type } = this.$route.query
    this.type = type
    if (type === 'add') {
      this.handleAddData()
    } else {
      this.handleEditData()
    }
  }
  /**
   * 处理新增时状态数据
   */
  async handleAddData() {
    const { cardHead, objectId, objectName } = this.$route.query
    const categoryList = await this.getCategoryList(objectId)
    this.form.categoryArr = categoryList
    this.form.objectId = objectId
    this.form.objectName = objectName
  }
  /**
   * 处理编辑时状态数据
   */
  async handleEditData() {
    const { objectId, formObj, type, objectName } = this.$route.query
    const { name, code, planCategoryId, description } = (formObj as any)
    const categoryList = await this.getCategoryList(objectId)

    this.form.categoryArr = categoryList
    this.form.name = name
    this.form.code = code
    this.form.description = description
    this.form.objectId = objectId
    this.form.categoryId = planCategoryId
    this.form.objectName = objectName
  }
}
